var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconePass",class:_vm.iconePass},[_c('img',{attrs:{"src":"/assets/images/pass.png","alt":"Icone Pass"}}),_c('label',{domProps:{"innerHTML":_vm._s(_vm.textePass)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }